var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterestGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40845_108269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2578 20.4522C15.7807 20.4522 20.2578 15.9762 20.2578 10.4546C20.2578 4.93311 15.7807 0.457031 10.2578 0.457031C4.73497 0.457031 0.257812 4.93311 0.257812 10.4546C0.257812 15.9762 4.73497 20.4522 10.2578 20.4522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54541 19.7361C6.42061 18.5988 6.50781 17.5118 6.75781 16.4621L7.75781 12.1507C7.59541 11.626 7.47021 11.0258 7.47021 10.4259C7.47021 9.02627 8.14541 8.02651 9.20781 8.02651C9.94541 8.02651 10.483 8.53878 10.483 9.52615C10.483 9.83847 10.4206 10.1884 10.2954 10.5883L9.85781 12.0255C9.77021 12.3007 9.73301 12.563 9.73301 12.7878C9.73301 13.7875 10.4954 14.3498 11.4706 14.3498C13.2082 14.3498 14.4458 12.5502 14.4458 10.2132C14.4458 7.61381 12.7458 5.95181 10.2334 5.95181C7.43341 5.95181 5.65861 7.77657 5.65861 10.3132C5.65861 11.3377 5.97101 12.2875 6.58381 12.9373C6.38381 13.2748 6.17141 13.3372 5.84621 13.3372C4.84621 13.3372 3.89621 11.9252 3.89621 10.0004C3.89621 6.67603 6.55861 4.02707 10.2962 4.02707C14.221 4.02707 16.6838 6.76401 16.6838 10.138C16.6838 13.512 14.2838 16.0866 11.6962 16.0866C10.671 16.0866 9.77101 15.6491 9.14621 14.8617L8.63381 16.9364C8.35861 18.0109 7.94621 19.0235 7.28381 19.998C8.22141 20.2856 9.14621 20.4479 10.259 20.4479C15.7838 20.4479 20.259 15.9738 20.259 10.4503C20.259 4.92685 15.783 0.453125 10.2578 0.453125C4.73261 0.453125 0.257812 4.92725 0.257812 10.4507C0.257812 14.6373 2.83301 18.2489 6.54541 19.7361Z",
    fill: "#C6CBD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40845_108269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.257812 0.453125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestGrey);
export default __webpack_public_path__ + "static/media/pinterestGrey.237ca565302c0ff36ab6b25a6abb9426.svg";
export { ForwardRef as ReactComponent };